import { CircularProgress } from "@mui/material";

//import styles
import "./base-button.scss";

export function BaseButton({ text, color, size, radius, rightIcon, leftIcon, loading, disabled, type, handleClick, style }) {
    return (
        <button className={`button ${color} ${size} ${radius} `} type={type} onClick={handleClick} disabled={loading || disabled} style={style}>
            {rightIcon}
            {loading ? <CircularProgress color="inherit" size={20} /> : text}
            {leftIcon}
        </button>
    );
}
